<template>
  <div class="sidebar">
    <!--<HeaderTemplate @change-view="handleHeaderViewChange" @logout="$emit('logout')"/>-->
    <div class="d-flex flex-column h-100">
      <!--<div class="sidebar-header p-4 mb-2">
        <h5 class="mb-0 fw-bold">Gestionale Pareri</h5>
        <p class="text-muted small mb-0">Backoffice</p>
      </div>-->
      <div class="p-3 sidebar-menu">
        <!--<ul class="nav nav-pills flex-column">
          <li class="nav-item">
            <a class="nav-link">
              <i class="bi bi-folder-fill"></i> Visualizzazioni
            </a>
          </li>
        </ul>
        <ul class="nav nav-pills flex-column" v-if="$root.user && $root.user.permissions.length">
          <li v-for="perm in $root.user.permissions" :key="perm" class="nav-item">
            <a v-if="permissionViewMap[perm]"
               class="nav-link"
               :class="{ active: currentView.name === permissionViewMap[perm].view }"
               @click="$emit('change-view', permissionViewMap[perm].view)">
              <i :class="permissionViewMap[perm].icon"></i>
              {{ permissionViewMap[perm].label }}
            </a>
          </li>
        </ul>-->
        <ul class="nav nav-pills flex-column" v-if="visibleMenus.length">
          <li v-for="menu in visibleMenus" :key="menu.label" class="nav-item">
            <!-- Se la voce ha figli -->
            <template v-if="menu.children && menu.children.length">
              <div class="nav-link d-flex justify-content-between align-items-center" @click="toggleMenu(menu.label)">
                <div><i :class="menu.icon"></i> {{ menu.label }}</div>
                <i class="bi" :class="openMenus.includes(menu.label) ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
              </div>

              <ul v-if="openMenus.includes(menu.label)" class="nav flex-column ms-3 mt-1 submenu">
                <li v-for="child in menu.children" :key="child.label" class="nav-item">
                  <a class="nav-link" :class="{ active: currentView === child.view }"
                    @click="$emit('change-view', child.view)">
                    <i :class="child.icon"></i> {{ child.label }}
                  </a>
                </li>
              </ul>
            </template>

            <!-- Se è una voce singola -->
            <template v-else>
              <a class="nav-link" :class="{ active: currentView === menu.view }"
                @click="$emit('change-view', menu.view)">
                <i :class="menu.icon"></i> {{ menu.label }}
                <span v-if="menu.view === 'ElencoDownloadView' && hasNewDownloads" class="new-badge">
                  NEW
                </span>
              </a>
            </template>
          </li>
        </ul>
        <!--<ul class="nav nav-pills flex-column">
          <li class="nav-item">
            <a class="nav-link" :class="{ active: currentView === 'DashboardView' }"
              @click="$emit('change-view', 'DashboardView')">
              <i class="bi bi-speedometer2"></i> Dashboard
            </a>
          </li>
        </ul>-->
      </div>
    </div>
  </div>
</template>

<script>

import HeaderTemplate from './Header.vue';
import eventBus from '../../services/eventBus.js';
//import { permissionViewMapImport } from '../../components/permissionMap.js';
import { menuMap } from '../../components/menuMap.js';

export default {
  name: 'SidebarTemplate',
  components: {
    HeaderTemplate
  },
  data() {
    return {
      requestCount: 0,
      unassigned: 0,
      hasNewDownloads: false,
      //permissionViewMap: permissionViewMapImport
      menuMap: menuMap,
      openMenus: ['Quesiti']
    }
  },
  props: {
    currentView: {
      type: String,
      required: true
    }
  },
  emits: ['change-view', 'logout'],
  computed: {
    userPermissions() {
      return this.$root.user?.permissions || [];
    },
    visibleMenus() {
      return this.menuMap
        .map(menu => {
          if (menu.children) {
            const visibleChildren = menu.children.filter(child => {
              if (child.anyPermissions) {
                return child.anyPermissions.some(p =>
                  this.userPermissions.includes(p)
                );
              }

              if (child.requiredPermissions) {
                return child.requiredPermissions.every(p =>
                  this.userPermissions.includes(p)
                );
              }

              return false;
            });

            return visibleChildren.length
              ? { ...menu, children: visibleChildren }
              : null;
          }

          // voce singola
          if (menu.anyPermissions) {
            return menu.anyPermissions.some(p =>
              this.userPermissions.includes(p)
            )
              ? menu
              : null;
          }

          if (menu.requiredPermissions) {
            return menu.requiredPermissions.every(p =>
              this.userPermissions.includes(p)
            )
              ? menu
              : null;
          }

          return null;
        })
        .filter(Boolean);
    }
  },
  methods: {
    onPdfReady() {
      this.hasNewDownloads = true;
    },
    handleHeaderViewChange(view) {
      // Propagare l'evento change-view dal HeaderTemplate
      this.$emit('change-view', view);
    },
    async updateUseRequestsCount() {
      if (this.$root.user.permissions.includes('manage-roles')) {
        try {
          //const response = await this.$root.$api.get('/count-requests')
          //this.requestCount = response.data.count
        } catch (error) {
          if (process.env.NODE_ENV === 'development') {
            console.error(error)
          }
        }
      }
    },
    async updateQuestionsCount() {
      if (this.$root.user.permissions.includes('publish-articles')) {
        try {
          const response = await this.$root.$api.get('/questions/unassigned')
          this.unassigned = response.data.count
        } catch (error) {
          if (process.env.NODE_ENV === 'development') {
            console.error(error)
          }
        }
      }
    },
    toggleMenu(label) {
      if (this.openMenus.includes(label)) {
        this.openMenus = this.openMenus.filter(l => l !== label);
      } else {
        this.openMenus.push(label);
      }
    }
  },
  created() {
    // Aggiungi un listener per l'evento update-request-count
    eventBus.on('update-request-count', this.updateUseRequestsCount);
    eventBus.on('update-question-count', this.updateQuestionsCount);
    eventBus.on('pdf-ready', this.onPdfReady);
    eventBus.on('downloads-view-opened', () => {
      this.hasNewDownloads = false;
    });
  },
  beforeUnmount() {
    // Rimuovi il listener quando il componente viene distrutto
    eventBus.off('update-request-count', this.updateUseRequestsCount);
    eventBus.off('update-question-count', this.updateQuestionsCount);
    eventBus.off('pdf-ready', this.onPdfReady);
  },
  async mounted() {
    console.log(this.permissionViewMap);
    console.log('Sidebar montato!');
    this.updateUseRequestsCount();
    this.updateQuestionsCount();
  },
}
</script>

<!--<style scoped>
.sidebar {
  width: 280px;
  height: calc(100vh-56px);
  position: fixed;
  left: 0;
  overflow-y: auto;
  background: linear-gradient(180deg, var(--bs-body-bg), var(--bs-tertiary-bg));
  box-shadow: 0 0 15px rgba(var(--bs-body-color-rgb), 0.05);
  z-index: 1000;
}

.sidebar-header {
  border-bottom: 1px solid rgba(var(--bs-body-color-rgb), 0.05);
}

.counter {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  top: -10px;
  right: -4px;
  min-width: 18px;
  height: 18px;
  font-size: 12px;
  font-weight: bold;
  border-radius: 10px;
  padding: 0.7em;
  padding-bottom: 0.8em;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  transform: scale(0.9);
  transition: all 0.2s ease;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(220, 53, 69, 0.7);
  }
  70% {
    box-shadow: 0 0 0 6px rgba(220, 53, 69, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(220, 53, 69, 0);
  }
}

.nav-link:hover .counter {
  transform: scale(1.1);
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.25);
  animation: none;
}

.nav-link {
  min-width: 100%;
  display: inline-flex;
  cursor: pointer;
  color: var(--bs-text-primary);
  padding: 0.75rem 1.25rem;
  border-radius: 0.5rem;
  margin: 0.25rem 0;
  font-weight: 500;
  transition: all 0.2s ease;
}

.nav-link:hover {
  background-color: rgba(74, 108, 247, 0.05);
  color: #0d6efd;
}

.nav-link.active {
  background-color: #0d6efd;
  color: white;
  box-shadow: 0 2px 8px rgba(74, 108, 247, 0.25);
}

.nav-link i {
  margin-right: 0.75rem;
  font-size: 1.1rem;
  vertical-align: -2px;
}

/* Sottomenu */

/* Stile per le voci di menu */
.nav-item {
  padding: 0.125rem 0;
}
</style>-->

<style scoped>
/* Sidebar: sfondo blu scuro e testo bianco */
.sidebar {
  width: 280px;
  height: calc(100vh) !important;
  position: fixed;
  left: 0;
  overflow-y: auto;
  background: #0A2342;
  /* blu scuro */
  color: #ffffff;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  padding-bottom: 1rem;
}

/* Forza il font (se vuoi) */
/* .sidebar, .sidebar * { font-family: "Avenir Next LT Pro", sans-serif !important; } */

/* Header border */
.sidebar-header {
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

/* Counter badge */
.counter {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  top: -10px;
  right: -4px;
  min-width: 18px;
  height: 18px;
  font-size: 12px;
  font-weight: bold;
  border-radius: 10px;
  padding: 0.25rem 0.4rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  transform: scale(0.9);
  transition: all 0.2s ease;
  animation: pulse 2s infinite;
  background: rgba(255, 255, 255, 0.12);
  color: #fff;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.12);
  }

  70% {
    box-shadow: 0 0 0 6px rgba(255, 255, 255, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
  }
}

/* Nav links base */
.nav-link {
  min-width: 100%;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  color: #ffffff !important;
  /* testo bianco */
  padding: 0.75rem 1.25rem;
  border-radius: 0.5rem;
  margin: 0.25rem 0;
  font-weight: 500;
  transition: background 0.12s ease, color 0.12s ease, transform 0.12s ease;
  background: transparent !important;
  /* rimuove eventuali bg di bootstrap */
  text-decoration: none;
}

/* Icone all'interno */
.nav-link i {
  margin-right: 0.5rem;
  font-size: 1.05rem;
  vertical-align: -2px;
  color: #ffffff !important;
}

/* Hover: leggero overlay chiaro (coerente su blu scuro) */
.nav-link:hover {
  background: rgba(255, 255, 255, 0.06) !important;
  color: #ffffff !important;
  transform: translateY(-1px);
}

/* Active: niente sfondo, testo bianco e sottolinea */
/* Usiamo underline semplice per rispettare la richiesta */
.nav-link.active {
  background: none !important;
  color: #ffffff !important;
  text-decoration: underline !important;
  text-underline-offset: 3px;
  /* distanzia l'underline dal testo */
  font-weight: 600;
  box-shadow: none !important;
}

/* Se hai link con icona e vuoi che l'icona segua lo stato active */
.nav-link.active i {
  color: #ffffff !important;
}

/* Sottomenu (indentazione e stile coerente) */
.submenu {
  margin-top: 0.25rem;
}

.submenu .nav-link {
  padding-left: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  background: transparent !important;
  border-radius: 0.4rem;
}

/* Rimuove i bordi blu/ombra impostati da bootstrap per .active .nav-link */
.nav-pills .nav-link.active {
  background: none !important;
  box-shadow: none !important;
}

/* Nav item spacing */
.nav-item {
  padding: 0.125rem 0;
}

/* Scrollbar (opzionale: migliora look della scrollbar nella sidebar) */
.sidebar::-webkit-scrollbar {
  width: 9px;
}

.sidebar::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.02);
}

.sidebar::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.06);
  border-radius: 10px;
}


@media (max-width: 991.98px) {
  .sidebar {
    position: relative;
    width: 100%;
    height: auto;
  }
}

.sidebar-menu {
  margin-top: 2rem;
}

.new-badge {
  margin-left: auto;
  background: #dc3545;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  padding: 2px 6px;
  border-radius: 10px;
  animation: pulse 1.8s infinite;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(220, 53, 69, 0.6);
  }

  70% {
    box-shadow: 0 0 0 6px rgba(220, 53, 69, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(220, 53, 69, 0);
  }
}

.new-badge {
  text-decoration: none !important;
  pointer-events: none;
}
</style>
